import defer from 'lodash-es/defer';
import each from 'lodash-es/each';
import keys from 'lodash-es/keys';
import some from 'lodash-es/some';
const topics = {};
const delayedThrow = (ex) => {
    throw ex;
};
const hasSubcribers = (topic) => {
    const split = topic.lastIndexOf(':') !== -1 ? ':' : '/';
    const parts = topic.split(split);
    let idx = parts.length;
    return some(parts, () => {
        const t = parts.slice(0, idx).join(split);
        idx -= 1;
        return !!(topics[t] && topics[t].size);
    });
};
const subscriberAsync = (subscriber, topic, data) => {
    try {
        subscriber(topic, ...data);
    }
    catch (ex) {
        defer(delayedThrow, ex);
    }
};
const subscriberSync = (subscriber, topic, data) => {
    subscriber(topic, ...data);
};
const deliverMessage = (topic, matchedTopic, data, immediateExceptions) => {
    if (!topics[matchedTopic] || topics[matchedTopic].size === 0) {
        return;
    }
    const callsub = immediateExceptions ? subscriberSync : subscriberAsync;
    topics[matchedTopic].forEach((subscriber) => {
        callsub(subscriber, topic, data);
    });
};
const createDeliveryFunction = (topic, data, immediateExceptions) => {
    return function deliverNamespaced() {
        deliverMessage(topic, topic, data, immediateExceptions);
        const split = topic.lastIndexOf(':') !== -1 ? ':' : '/';
        const parts = topic.split(split);
        for (let x = parts.length - 1; x > 0; --x) {
            const parent = parts.slice(0, x).join(split);
            deliverMessage(topic, parent, data, immediateExceptions);
        }
    };
};
const publishAction = (topic, data, sync, immediateExceptions) => {
    if (!hasSubcribers(topic)) {
        return false;
    }
    const deliver = createDeliveryFunction(topic, data, immediateExceptions);
    if (sync) {
        deliver();
    }
    else {
        defer(deliver);
    }
    return true;
};
const createHandle = (list, subscriber) => {
    return {
        destroy() {
            list.delete(subscriber);
        }
    };
};
export const publish = (topic, ...data) => {
    return publishAction(topic, data, false, false);
};
export const publishSync = (topic, ...data) => {
    return publishAction(topic, data, true, false);
};
export const subscribe = (topic, subscriber) => {
    if (!topics[topic]) {
        topics[topic] = new Set();
    }
    const subs = topics[topic];
    subs.add(subscriber);
    return createHandle(subs, subscriber);
};
export const clearTopic = (topic, cascade = false) => {
    if (topics[topic]) {
        delete topics[topic];
    }
    if (cascade) {
        const topiclead = new RegExp(`^${topic}[/:]`);
        each(keys(topics), (t) => {
            if (topiclead.test(t)) {
                delete topics[t];
            }
        });
    }
};
